import colors from "#src/styles/colors.json" with { type: "json" };

export default colors;
